import React from 'react'
import { Routes, Route } from 'react-router-dom'
import PatientManagement from './PatientManagement'
import DiagnosisWorkspace from './DiagnosisWorkspace'
import ConsultationManagement from './ConsultationManagement'

const Diagnosis: React.FC = () => {
  return (
    <Routes>
      <Route index element={<PatientManagement />} />
      <Route path="workspace/:patientId" element={<DiagnosisWorkspace />} />
      <Route path="consultation" element={<ConsultationManagement />} />
    </Routes>
  )
}

export default Diagnosis

